import type { UnregisterMobilePushEndpointRequest } from '@DigitaleDoerfer/digitale-doerfer-api';

import { useSharedPushApi } from '@/features/api/hooks/shared-push/useSharedPushApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useUnregisterMobilePushEndpoint = () => {
  const api = useSharedPushApi();

  return useApiMutation({
    mutationFn: (request: UnregisterMobilePushEndpointRequest) =>
      api.unregisterMobilePushEndpoint(request)
  });
};
